export function isValidFileSize(file: File, sizeInMb: number) {
  return file.size < sizeInMb * 1024 * 1024;
}
